import React from 'react';
import {
  highlightWithSummaryUpdate,
  unhighlightWithSummaryUpdate,
} from './textHighlight';

/**
 * Reusable Highlight / Unhighlight buttons for contenteditable flows
 * that copy selected text into a summary field (e.g. Mission Statement).
 */
export default function TextHighlightToolbar({
  summaryContent = '',
  onSummaryChange,
  useBold = false,
  className = '',
  buttonClassName = 'highlightBtn',
  style,
  highlightLabel = 'Highlight',
  unhighlightLabel = 'Unhighlight',
}) {
  const handleHighlight = () => {
    const nextSummary = highlightWithSummaryUpdate(summaryContent, { useBold });
    if (onSummaryChange) {
      onSummaryChange(nextSummary);
    }
  };

  const handleUnhighlight = () => {
    const nextSummary = unhighlightWithSummaryUpdate(summaryContent, { useBold });
    if (onSummaryChange) {
      onSummaryChange(nextSummary);
    }
  };

  return (
    <div className={className} style={style}>
      <button type="button" className={buttonClassName} onClick={handleHighlight}>
        {highlightLabel}
      </button>
      <button
        type="button"
        className={buttonClassName}
        onClick={handleUnhighlight}
        style={{ marginLeft: '10px' }}
      >
        {unhighlightLabel}
      </button>
    </div>
  );
}
